import { Image } from 'react-datocms';
import { Heading } from '@zopauk/web-ui';
import { twMerge } from 'tailwind-merge';
import B2BIcon from '@/components/Modules/B2BIcon';
import { StripItemFragment, StripFragment } from '@/utils/dato/generated';

type StripItemProps = { stripVariant: StripFragment['variant'] } & StripItemFragment;
type StripItemTitleProps = Pick<StripItemProps, 'stripItemTitle' | 'stripVariant'>;

const StripItemTitle = ({ stripItemTitle, stripVariant }: StripItemTitleProps) => {
  if (stripVariant === 'data-panel') {
    return (
      <Heading className="strip-title mb-0" size="h1" as="h3">
        {stripItemTitle}
      </Heading>
    );
  }

  return <span className={twMerge('strip-title font-serif block mb-2')}>{stripItemTitle}</span>;
};

export const StripItem = ({ stripItemTitle, stripVariant, description, image, icon }: StripItemProps) => (
  <div className="md:px-4 md:w-auto lg:flex-1">
    {image?.responsiveImage ? (
      <div className="w-full mb-6">
        <Image data={image?.responsiveImage} style={{ margin: '0 auto' }} objectPosition="50% 50%" />
      </div>
    ) : null}

    {icon && !image ? <B2BIcon icon={icon} /> : null}

    {stripItemTitle ? <StripItemTitle stripItemTitle={stripItemTitle} stripVariant={stripVariant} /> : null}

    {description ? <p className="strip-description">{description}</p> : null}
  </div>
);
